import { Tag } from 'antd';
import styled from 'styled-components';

export const SOverflowList = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;
`;

export const SVisibleItems = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SOverflowCount = styled(Tag)`
    flex-shrink: 0;
    user-select: none;
    border-radius: 2px;
    background-color: var(--gray-2);
`;
